import { InjectionToken } from '@angular/core';

export const SKIP_AUTH_URLS = new InjectionToken<string[]>('SKIP_AUTH_URLS', {
  providedIn: 'root',
  factory: () => ['.s3.amazonaws.com', 's3.amazonaws.com'],
});
